import React from 'react';
import './TopBanner.css';

const TopBanner = () => {
    return (
        <div className="top-banner">
           <h1>Soccer Leagues</h1>
        </div>
    );
};

export default TopBanner;